module.exports = __webpack_public_path__ + "2e526a52a719192f660758411e2a6bd5.svg";